import React, { useEffect, useState , useRef } from "react";
import GoogleIcon from "../../assets/imgs/google-icon.svg";
import RotobotBg from "../../assets/imgs/rotobot_bg.jpg";
import { Button } from "../ui/button";
import { useSupabaseAuth } from "../../Context/AuthContext/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import useFirebaseAnalytics from "../../hooks/useFirabaseAnality";
import { useMixpanel } from "../../../src/Context/MixpanelContext/MixpanelProvider";
import ChatbotImg from "../../assets/imgs/ai-chat-logo.svg";
import rotobotLogin from "../../assets/imgs/rotobot_login_text.svg";
import appleBlack from "../../assets/imgs/apple_black.svg";
import phoneIcon from "../../assets/imgs/phone_icon.svg";
import AnimatedPage from "../../Routes/AnimatedPage";
import { Capacitor } from "@capacitor/core";

export const Login: React.FC = () => {
  const { logEventAnalytics } = useFirebaseAnalytics();
  const navigate = useNavigate();
  const { signInWithGoogle, signInWithApple } = useSupabaseAuth();
  const { useAuthStore } = useSupabaseAuth();
  const user = useAuthStore((state: any) => state.user);
  const Mixpanel = useMixpanel();
  const location = useLocation();
  const platform = Capacitor.getPlatform();
  const hasTracked = useRef(false);

  const handleGoogleSignIn = async () => {
    console.log("handle google Sign In");
    logEventAnalytics("login_selected_google", {
      name: "User selects to sign in with google",
    });
    Mixpanel.trackEvent("login_selected_google ", {
      name: "User selects to sign in with google",
    });
    try {
      const response = await signInWithGoogle();
      console.log(response);
    } catch (error) {
      console.log("error handle google Sign In " + error);
    }
  };

  const handleAppleSignIn = async () => {
    console.log("handle Apple Sign In");
    logEventAnalytics("login_selected_apple", {
      name: "User selects to sign in with apple",
    });
    Mixpanel.trackEvent("login_selected_apple", {
      name: "User selects to sign in with apple",
    });
    try {
      const response = await signInWithApple();

      console.log(response);
    } catch (error) {
      console.log("error handle Apple Sign In " + error);
    }
  };



useEffect(() => {
  if (!hasTracked.current) {
    Mixpanel.trackEvent("sign_in_screen viewed", {
      name: "User views sign in screen",
    });
    hasTracked.current = true;
  }
}, []);
  // Forward animation (default direction)

  return (
    <AnimatedPage
      backward={
        location.state && location.state.from === "verification-phone-number"
          ? true
          : false
      }
    >
      <div
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 14.61%, rgba(0, 0, 0, 0.4) 49.59%, #092239 70.89%), url(${RotobotBg})`,
          boxSizing: "border-box",
          width: "100vw",
          height: "100svh",
          overflowY: "auto",
          imageRendering: "crisp-edges",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: `${"center center"}`,
        }}
        className="no-select"
      >
        <div className="p-6 w-full h-screen flex items-end pb-12">
          {/* Changed to h-screen and added flex items-end */}
          <div className="w-full">
            <div className="flex flex-col items-center justify-center w-full space-y-3">
              <img
                src={ChatbotImg}
                alt="ChatbotImg"
                className="w-[59px] h-[45px]"
              />
              <img src={rotobotLogin} alt="rotobotLogin" />
            </div>

            <div className="flex flex-col justify-between m-auto">
              <div className="w-full mt-8">
                <div className="w-full flex flex-col gap-[12px] ">
                  {platform !== 'android' && (
                    <Button
                      variant="outline"
                      className="h-12 gap-3 md:gap-4 lg:gap-5 bg-white text-black"
                      onClick={handleAppleSignIn}
                    >
                      <img src={appleBlack} alt="AppleIcon" />
                      <span className="text-[16px] font-semibold">
                        Continue with Apple
                      </span>
                    </Button>
                  )}

                  <Button
                    variant="outline"
                    className="h-12 gap-3 md:gap-4 lg:gap-5 bg-white text-black"
                    onClick={handleGoogleSignIn}
                  >
                    <img src={GoogleIcon} alt="GoogleIcon" />
                    <span className="text-[16px] font-semibold">
                      Continue with Google
                    </span>
                  </Button>

                  <Button
                    variant="outline"
                    className="h-12 gap-3 md:gap-4 lg:gap-5 text-base md:text-lg lg:text-xl bg-white/10 text-white"
                    onClick={() => {
                      console.log("handle phone Sign In");
                      logEventAnalytics("login_selected_phone", {
                        name: "User selects to sign in with phone",
                      });
                      Mixpanel.trackEvent("login_selected_phone", {
                        name: "User selects to sign in with phone",
                      });
                      navigate("/verify-phone-number", {
                        state: {
                          from: "login",
                        },
                      });
                    }}
                  >
                    <img
                      src={phoneIcon}
                      alt="phoneIcon"
                      className="w-[18.4px] "
                    />
                    <span className="text-[16px] font-semibold">
                      Continue with Phone
                    </span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedPage>
  );
};
